<template>
  <div class="kpt-detail-field">
    <span class="kpt-detail-field-label has-text-grey" :style="`width:${labelWidth}px;min-width:${labelWidth}px;`">
      <slot name="label"></slot>
      <span>:</span>
    </span>
    <span class="kpt-detail-field-value">
      <slot name="value"></slot>
    </span>
  </div>
</template>
<script>
export default {
  name: 'DetailField',
  props: {
    labelWidth: {
      type: String,
      default: '120'
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-detail-field {
  display: flex;

  .kpt-detail-field-label {
    display: flex;
    justify-content: space-between;
    margin-right: 5px;
  }
  .kpt-detail-field-value {

  }
}
</style>
